import { Box, Typography } from "@mui/material";
import { StaffListType } from "../../../constants/staff_list";

const StaffCard: React.FC<StaffListType> = ({ image, name, position }) => {
  return (
    <Box
      sx={{
        width: "100%",
        textAlign: "center",
      }}
    >
      <img
        src={image}
        style={{
          width: "100%",
          height: "200px",
          borderRadius: "8px",
          objectFit: "contain",
        }}
      />

      <Typography
        sx={{
          marginTop: "10px",
          fontSize: "24px",
          fontWeight: "300",
        }}
      >
        {name}
      </Typography>

      <Typography variant="subtitle2">{position}</Typography>
    </Box>
  );
};

export default StaffCard;
